import { FormattedMessage } from 'react-intl';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { LiveDot } from '@sorare/core/src/components/live/LiveDot';
import { glossary } from '@sorare/core/src/lib/glossary';

type Props = {
  withLiveDot?: boolean;
  onClick: () => void;
};
export const TodayButton = ({ withLiveDot, onClick }: Props) => {
  return (
    <Button color="secondary" size="small" onClick={onClick}>
      {!!withLiveDot && <LiveDot animate />}
      <FormattedMessage {...glossary.today} />
    </Button>
  );
};
